export type ColorString = string;
export type Theme = {
	bgColor:ColorString,
	pageActiveBgColor:ColorString,
	
	bgColorLight:ColorString,
	memoBtnColor:ColorString,
	txtColor:ColorString,
	highlightColor:ColorString,
	calCol:ColorString,
	errorCol:ColorString,
	fontSize: {s:string,m:string,l:string},
	titleSize: {s:string,m:string,l:string},
}

export const curTheme:Theme = {
	// bgColor:'#ffffff',
	bgColor:'var(--mmb-popup-bg-col)',
	memoBtnColor:'var(--memo-btn-color)',
	pageActiveBgColor:'#ffffff',
	bgColorLight:'#ededed',
	txtColor:'#222222',
	highlightColor:'#FFD900',
	calCol:'#222222',
	errorCol:'#E56717',
	fontSize:{s:'var(--rpp-fz-s)',m:'var(--rpp-fz-m)',l:'var(--rpp-fz-l)'},
	titleSize:{s:'var(--rpp-title-fz-s)',m:'var(--rpp-title-fz-m)',l:'var(--rpp-title-fz-l)'},
};